module.exports = __webpack_public_path__ + "static/turtle-creek-house21-e158cb09d3df6059692e71ff0c7ae8b8.jpg";